import { IntegrationIconProps } from './types';

const Flickr = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 15.9997C17 19.3132 19.6866 22 23.0005 22C26.3139 22 29 19.3132 29 15.9997C29 12.6862 26.3139 10 23.0005 10C19.6866 10 17 12.6862 17 15.9997Z"
      fill="#FF0084"
    />
    <path
      d="M3 15.9997C3 19.3132 5.68611 22 9 22C12.3139 22 15 19.3132 15 15.9997C15 12.6862 12.3139 10 9 10C5.68611 10 3 12.6862 3 15.9997Z"
      fill="#0063DC"
    />
  </svg>
);
export default Flickr;
